import { render, staticRenderFns } from "./event-setting-panel.vue?vue&type=template&id=2ed6d42a&scoped=true"
import script from "./event-setting-panel.vue?vue&type=script&lang=js"
export * from "./event-setting-panel.vue?vue&type=script&lang=js"
import style0 from "./event-setting-panel.vue?vue&type=style&index=0&id=2ed6d42a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed6d42a",
  null
  
)

export default component.exports